<template>
  <!-- <div style="width: 367px; transform: scale(0.8); transform-origin: top center;"> -->
  <div style="width: 367px; margin-top: 2px;" :style="boardStyle">
    <div class="board">
      <div v-for="(row, i) in board" :key="'r' + i">
        <Card v-for="(col, j) in row" :key="'c' + j" @click="playTile((i * 10) + j)"
          :card="col" :overlayColor="tileColor((i * 10) + j)" :isLastPlayed="tileIsLastPlayed((i * 10) + j)" />
      </div>
    </div>

    <div v-if="showPlayerTray" style="display: flex; margin-top: 10px;">
      <div class="trayitem" style="font-size: 10px;" :style="{ backgroundColor: $store.getters.topDiscardColor }"
        @click="discardPileClicked">
        <div style="display: flex; justify-content: center;"><Card :card="$store.getters.topDiscardCard" /></div>
        <div style="padding: 3px 0px;">discard</div>
      </div>
      <div style="flex: 1;"></div>
      <div class="trayitem" style="font-size: 10px; background-color: black;" @click="drawCard">
        <div style="display: flex;"><Card card="WW" /></div>
        <div style="padding: 3px 0px;">draw</div>
      </div>
      <div style="flex: 1;"></div>
      <div class="trayitem" :style="{ backgroundColor: handColor }">
        <div style="display: flex; justify-content: center;">
          <Card v-for="(card, i) in hand" :key="'h' + i"
          :card="card" :selected="selectedHandIndex == i" @click="selectHandCard(i)" />
        </div>
        <div>your hand</div>
      </div>
    </div>

    <div class="footer" style="align-items: center;">
      <div v-if="turnText" @click="turnTextClicked" class="turn">
        <span :style="{ borderBottom: turnTextBorder }">{{ turnText }}</span>
      </div>
      <a v-if="nextGameText" href="javascript:void(0);" @click="nextGameClicked">{{ nextGameText }}</a>
      <img :src="soundOn ? require('@/assets/sound-on.svg') : require('@/assets/sound-off.svg')" @click="toggleSound" style="margin-right: 4px;">
      <div @click="howToPlayClicked" class="help">How to play</div>
    </div>

    <Modal v-model="showPlayersModal" title="Player Discard Piles">
      <div v-for="player in discardPilePlayers" :key="'p' + player.id" style="display: flex; margin-bottom: 5px;">
        <div style="padding: 4px; display: flex; border-radius: 4px; " :style="{ backgroundColor: player.color == 'b' ? 'blue' : (player.color == 'g' ? 'green' : 'red') }"><Card :card="player.discard ? player.discard : 'WW'" /></div>
        <div style="font-size: 20px; padding: 10px;">{{ player.name }}</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import sharedUtils from '../shared/utils.js'
import Card from './Card.vue'
import Modal from './Modal.vue'
import { EventBus } from '@/events.js'
import confetti from 'canvas-confetti'

export default {
  name: 'GameBoard',
  components: { Card, Modal },
  data: function () { return {
    board: sharedUtils.boardLayout(),
    chime: new Audio(require('@/assets/chime.wav')), // https://freesound.org/people/ertfelda/sounds/243701/
    publicPath: process.env.BASE_URL,
    selectedHandIndex: -1,
    selectedChain: [],
    soundOn: false,
    shouldPlayChime: false,
    showPlayersModal: false
  } },

  watch: {
    pendingChain (chain) { this.preselectChain(chain); },
    currentPlayer () {
      if (!this.currentPlayer || !this.$store.state.player) { return; }
      if (this.currentPlayer.id !== this.$store.state.player.id) { this.shouldPlayChime = false; }
      else if (!this.shouldPlayChime) { this.shouldPlayChime = true; }
    },
    shouldPlayChime () {
      if (this.soundOn && this.shouldPlayChime) { this.chime.play(); }
    },

    // If a player wins the game, show some fun confetti!
    '$store.state.game.has_ended' (val) {
      // Only show the game-winning confetti if this player is on the winning team...
      if (val === '_' || val !== this.$store.state.player.color) { return; }

      for (var i = 0; i < 3; i++) {
        setTimeout(function () {
          confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 }
          });
        }, i * 400);
      }
    }
  },

  computed: {
    currentPlayer () { return this.$store.getters.currentPlayer },
    discardPilePlayers () {
      let players = [];
      for (let i = 0; i < this.$store.getters.gamePlayers.length; i++) {
        let player = this.$store.getters.gamePlayers[i];
        if (player.color == 'o') { continue; }
        players.push(player);
      }
      return players;
    },

    showPlayerTray () {
      if (!this.$store.state.player || this.$store.state.player.color == 'o') { return false; }
      return true;
    },

    boardStyle () {
      if (window.innerHeight > 800) {
        let left = parseInt((window.innerWidth - 367) / 2) + 'px';
        let top = parseInt((window.innerHeight - 800) / 2) + 'px';
        return { position: 'absolute', top: top, left: left };
      }
      let scale = window.innerHeight / 800;
      const w = scale * 367;
      const h = scale * 800;
      let left = parseInt((window.innerWidth - w) / 2) + 'px';
      let top = parseInt((window.innerHeight - h) / 2) + 'px';
      return { transform: 'scale(' + scale + ')', transformOrigin: 'top left', position: 'absolute', top: top, left: left };
    },
    handColor () {
      if (!this.$store.state.player) { return 'black'; }
      if (this.$store.state.player.color == 'b') { return 'blue'; }
      if (this.$store.state.player.color == 'g') { return 'green'; }
      if (this.$store.state.player.color == 'r') { return 'red'; }
      return 'black';
    },
    turnText () { return this.pendingChain.length ? 'select your chain' : this.$store.getters.playerTurnText; },
    turnTextBorder () {
      if (!this.currentPlayer) { return '0px'; }
      return '2px solid ' + (this.currentPlayer.color == 'b' ? 'blue' : (this.currentPlayer.color == 'g' ? 'green' : 'red'));
    },
    nextGameText () {
      if (this.$store.getters.gameHasEnded) {
        return this.$store.getters.nextGameAuth != '' ? 'Play again!' : 'Play again?';
      }
      return '';
    },
    hand () { return this.$store.getters.gamePlayerHand; },
    selectedHandCard () {
      if (this.selectedHandIndex < 0 || this.selectedHandIndex >= this.hand.length) { return ''; }
      return this.hand[this.selectedHandIndex];
    },
    pendingChain () {
      if (!this.$store.getters.isPlayerTurn) { return []; }
      return this.$store.getters.pendingChain;
    }
  },

  methods: {
    preselectChain (chain) {
      if (chain.length) {
        if (chain.length == 6) { this.selectedChain = chain.slice(1, 5); }
        else if (chain.length == 7) { this.selectedChain = chain.slice(2, 5); }
        else if (chain.length == 8) { this.selectedChain = chain.slice(3, 5); }
        else if (chain.length == 9) { this.selectedChain = chain.slice(4, 5); }
      }
    },
    cardImage (card) {
      return require('../assets/cards/' + card + '.png');
    },
    selectHandCard (handIndex) {
      if (handIndex === this.selectedHandIndex) { this.selectedHandIndex = -1; }
      else if (handIndex >= 0 && handIndex < this.hand.length) { this.selectedHandIndex = handIndex; }
    },
    selectSequenceCard (tile) {
      this.selectedSequence.push(tile);
    },
    selectChain (tile) {
      if (this.pendingChain.indexOf(tile) >= 0) {
        if (this.selectedChain.indexOf(tile) >= 0) { this.selectedChain.splice(this.selectedChain.indexOf(tile), 1); }
        else { this.selectedChain.push(tile); }
      }

      let chainFinal = sharedUtils.finalSelectedChain(this.pendingChain, this.selectedChain);
      if (chainFinal.length == 5) {
        this.$store.dispatch('playerSelectChain', { chain: chainFinal });
        this.selectedChain = [];
      }
    },
    toggleSound () {
      this.soundOn = !this.soundOn;
      if (this.soundOn) { this.chime.play(); }
    },
    playTile (tile) {
      if (this.pendingChain.length) { this.selectChain(tile); return; }

      var card = sharedUtils.cardAtBoardTile(tile);

      // If playing a jack, the rules for which cards we can select are different...
      if (this.selectedHandCard.charAt(0) == 'J') {
        card = this.selectedHandCard;
        var tileColor = this.$store.getters.tileColor(tile);

        // one-eyed jacks remove
        if (card.charAt(1) == 'S' || card.charAt(1) == 'H') {
          if (tileColor === 'b' || tileColor === 'g' || tileColor === 'r') {
            this.$store.dispatch('playerTakeTurn', { card: card, tile: tile });
            this.selectedHandIndex = -1;
          }
          else {
            alert('cannot play one-eyed jack to remove here');
          }
        }

        // two-eyed jacks are wild...
        else {
          if (tileColor === '_') {
            this.$store.dispatch('playerTakeTurn', { card: card, tile: tile });
            this.selectedHandIndex = -1;
          }
          else {
            alert('cannot play two-eyed jack as wild here');
          }
        }
      }

      // Otherwise, they must have this card in their hand...
      else if (this.hand.indexOf(card) >= 0) {
        if (this.selectedHandCard === '' || this.selectedHandCard == card) {
          this.$store.dispatch('playerTakeTurn', { card: card, tile: tile });
          this.selectedHandIndex = -1;
        }
        else {
          alert('select this card in your hand before you play it');
        }
      }
    },
    tileColor (tile) {
      let color = this.$store.getters.tileColor(tile);
      if (!color) { return ''; }

      // If the user is selecting a chain, show the ones that are already selected...
      if (this.pendingChain.length && this.selectedChain.indexOf(tile) >= 0) { return 'rgba(255, 192, 0, 0.7)'; }

      if (color == 'b') { return 'rgba(0, 51, 204, 0.4)'; }
      if (color == 'g') { return 'rgba(53, 153, 0, 0.4)'; }
      if (color == 'r') { return 'rgba(204, 51, 0, 0.5)'; }
      if (color == 'B') { return 'rgba(0, 51, 204, 0.7)'; }
      if (color == 'G') { return 'rgba(53, 153, 0, 0.7)'; }
      if (color == 'R') { return 'rgba(204, 51, 0, 0.8)'; }
      return '';
    },
    tileIsLastPlayed (tile) {
      if (this.$store.state.game.last_tile == 0 || this.$store.state.game.last_tile == 127) { return false; }
      return tile == this.$store.state.game.last_tile;
    },
    attemptDeadCard () {
      // If the user has selected a card, and it is a dead card, attempt to switch it out...
      if (this.selectedHandCard !== '') {
        if (sharedUtils.isCardDead(this.selectedHandCard, this.$store.state.game.tile_claims)) {
          this.$store.dispatch('playerDeadCard', { card: this.selectedHandCard });
          return true;
        }
      }
      return false;
    },
    drawCard () {
      // If the user has selected a card, and it is a dead card, attempt to switch it out...
      if (this.attemptDeadCard()) { return; }

      // Otherwise, we draw a card. TODO: Could use more client-side checks, but server's got us.
      this.$store.dispatch('playerDrawCard');
    },
    discardPileClicked () {
      // If the user has selected a card, and it is a dead card, attempt to switch it out...
      if (this.attemptDeadCard()) { return; }

      this.showPlayersModal = true;
    },
    turnTextClicked () { this.showPlayersModal = true; },
    howToPlayClicked () { EventBus.$emit('howto'); },
    nextGameClicked () {
      if (this.$store.getters.nextGameAuth == '') {
        this.$store.dispatch('nextGame');
        return;
      }

      this.$router.push('/g/' + this.$store.getters.nextGameAuth);
    }
  },

  mounted () {
    if (this.pendingChain.length && !this.selectedChain.length) { this.preselectChain(this.pendingChain); }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.board {
  background-color: #555;
  border: 3px solid #555;
  border-radius: 4px;
  overflow: hidden;
}

.board > div {
  display: flex;
}

.trayitem {
  cursor: pointer;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  padding: 4px;
  padding-bottom: 0px;
  border-radius: 4px;
}

.footer {
  display: flex;
  margin-top: 10px;
}

.footer .turn {
  flex: 1;
  overflow: hidden;
  cursor: pointer;
  padding-bottom: 2px;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.footer a {
  flex: 1;
  text-align: left;
  padding-left: 10px;
  color: #2c3e50;
  font-weight: bold;
}

.footer .help {
  cursor: help;
}
</style>
